module.exports = __webpack_public_path__ + "img/fedea.8fec94b0.png";